export const documentation = {
  junior: [
    { name: 'UX Research Methods Guide', url: '/docs/ux-research-methods', type: 'methodology' },
    { name: 'User Interview Best Practices', url: '/docs/user-interviews', type: 'interviews' },
    { name: 'Usability Testing Procedures', url: '/docs/usability-testing', type: 'testing' },
    { name: 'Survey Design Guidelines', url: '/docs/survey-design', type: 'surveys' },
    { name: 'Research Documentation Standards', url: '/docs/research-documentation', type: 'documentation' }
  ],
  mid: [
    { name: 'Advanced Research Techniques', url: '/docs/advanced-research', type: 'methodology' },
    { name: 'Quantitative Research Methods', url: '/docs/quantitative-research', type: 'quantitative' },
    { name: 'Research Operations Framework', url: '/docs/research-ops', type: 'operations' },
    { name: 'Data Analysis for UX Research', url: '/docs/research-data-analysis', type: 'analysis' },
    { name: 'Research Synthesis Techniques', url: '/docs/research-synthesis', type: 'synthesis' }
  ],
  senior: [
    { name: 'Research Strategy Development', url: '/docs/research-strategy', type: 'strategy' },
    { name: 'Building Research Teams', url: '/docs/research-team-building', type: 'leadership' },
    { name: 'Research Impact Measurement', url: '/docs/research-impact', type: 'impact' },
    { name: 'Advanced Analytics for Research', url: '/docs/advanced-research-analytics', type: 'analytics' },
    { name: 'Research Program Management', url: '/docs/research-program-management', type: 'management' }
  ]
};
